import React from 'react'
import classNames from 'classnames'

import Base, { BaseProps } from '../Base'
import style from './style.module.css'

type ListProps = BaseProps<'ul'>

export function List({ as = 'ul', mb = '10', className, ...rest }: ListProps) {
  return (
    <Base
      as={as}
      mb={mb}
      className={classNames(style.list, className)}
      {...rest}
    />
  )
}

type ListItemProps = BaseProps<'li'>

export function ListItem({ as = 'li', className, ...rest }: ListItemProps) {
  return (
    <Base as={as} className={classNames(style.listItem, className)} {...rest} />
  )
}

type ListItemKeyProps = BaseProps<'div'>

export function ListItemKey({
  as = 'div',
  className,
  ...rest
}: ListItemKeyProps) {
  return (
    <Base
      as={as}
      className={classNames(style.listItemKey, className)}
      {...rest}
    />
  )
}

type ListItemValueProps = BaseProps<'div'>

export function ListItemValue({
  as = 'div',
  className,
  ...rest
}: ListItemValueProps) {
  return (
    <Base
      as={as}
      className={classNames(style.listItemValue, className)}
      {...rest}
    />
  )
}
